module.exports = __webpack_public_path__ + "img/streamingtab-dark.76d2075c.svg";